module.exports = __webpack_public_path__ + "img/onboarding-01.6316f37e.png";